var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-black)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.25.5 2.704 5.478L18 6.86l-4.375 4.262 1.033 6.02-5.408-2.844-5.408 2.843 1.033-6.02L.5 6.863l6.046-.885z"
  })));
};
export default SvgStar;